import Dexie from 'dexie'

export const dexie = new Dexie('carnazzola')
dexie.version(1).stores({
  typologies: '++id, key, children, value, order', // Primary key and indexed props,
  locations: '++id, key, value'
})
